'use client';

import iconCoinSmall from '@/assets/images/icons/coin-small.png';
import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import IconTextUnit from '../../../../components/ui/IconTextUnit/IconTextUnit';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatCurrency } from '../../../../utils/formatters';
import type { CoinMenu } from '../../types';
import styles from './PurchaseMenu.module.scss';

type Props = {
  items: CoinMenu[];
  onPurchaseClick: (item: CoinMenu) => void;
};

function PurchaseMenu({ items, onPurchaseClick }: Props) {
  return (
    <ul className={styles.purchaseMenu}>
      {items.map((item) => (
        <li key={`${item.id}`}>
          <div className={`${styles.menuItem}`}>
            <IconTextUnit text={formatCurrency(item.taxIncludedPrice)} imgSrc={iconCoinSmall.src} />
            <div className={`${styles.itemDetail} ${utilsStyles.textLarge} ${utilsStyles.textBold}`}>
              <span>¥{formatCurrency(item.taxIncludedPrice)}</span>
            </div>
            <ActionButton
              color='primary'
              size={'small'}
              onClick={() => {
                onPurchaseClick(item);
              }}
            >
              購入
            </ActionButton>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default PurchaseMenu;
